module.exports = __webpack_public_path__ + "static/media/lbd23.57d4f139.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lbd23.jpg
// module id = 204
// module chunks = 0